import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { View } from "@-/com.npmjs.react-native";

/**
 * One label/value line in the dictionary Overview's right-hand column (Rank, HSK/TBCL level,
 * Characters). Every stat in both the grapheme and word overviews renders through this so the
 * rows stay typographically identical — a stat added to one morpheme type cannot drift from the
 * other.
 */
export function MorphemeInfoPanelDictionaryStatRow({
  label,
  value,
}: {
  /** Shown as-is; callers include their own trailing colon. */
  label: string;
  value: string;
}) {
  return (
    <View className="flex-row items-center justify-between">
      <Text className="text-[17px] leading-tight text-muted-foreground">{label}</Text>
      <Text className="text-[17px] leading-tight text-foreground">{value}</Text>
    </View>
  );
}
